import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  loadMore: {
    position: 'absolute',
    borderRadius: 20,
    fontSize: 14,
    left: '54%',
    top: 60,
    height: 30,
  },
  loadMoreIcon: {
    fontSize: 'medium',
  },
});
